<template>
  <OnboardingLayout
    title="ZedLite starts here!"
    :imageDescription="welcomeText"
    description="Join thousands of Arnergy users all over Africa who are enjoying uninterrupted power supply with our solar solution."
    @onButtonClick="handleContinue"
    :canContinue="canContinue"
  >
    <template slot="subtext">This is a ZedLite customer</template>
    <div class="choose-package">
      <!-- Display this if It's IPP -->
      <div class="choice-type">Choose a device type</div>

      <div v-if="showLoading">
        <vue-skeleton-loader noOfCell="3"></vue-skeleton-loader>
      </div>

      <div v-if="!showLoading && products.length < 1">
        there are have 0 products onboarded, kindly contact admin
      </div>

      <div class="package">
        <div v-for="item in products" :key="item.id">
          <onboarding-select-button
            :ID="item.id"
            :title="item.name"
            :description="item.productDescription"
            :image="
              item.url_image
                ? item.url_image
                : require('@/assets/img/arnergy-5000.png')
            "
            :isActive="activeProduct && activeProduct.id == item.id"
            @setActive="setActiveProduct(item)"
          />
        </div>
      </div>
    </div>
  </OnboardingLayout>
</template>

<script>
/* eslint-disable */
import ButtonOnboardingPackage from "@/components/pages/kitchen/ButtonOnboardingPackage";
import ModalCalculate from "@/components/pages/kitchen/Onboarding/ModalCalculate";
import ModalMain from "@/components/pages/kitchen/Onboarding/ModalMain.vue";
import SideIndicator from "@/components/pages/kitchen/Onboarding/SideIndicator.vue";
import OnboardingSelectButton from "@/components/pages/kitchen/OnboardingSelectButton";
import MoneyFormat from "vue-money-format";
import { mapGetters } from "vuex";

import OnboardingButton from "@/components/OnboardingButton.vue";
import OnboardingTopBar from "@/components/OnboardingTopBar.vue";
import OnboardingLayout from "@/components/layouts/onboarding-layout.vue";

import VueSkeletonLoader from "@/components/SkeletonLoader.vue";
import OnboardingService from "@/services/onboarding.js";

export default {
  name: "OnboardIPP",
  computed: {
    ...mapGetters(["getUserSession"]),
  },
  components: {
    OnboardingLayout,
    ButtonOnboardingPackage,
    OnboardingSelectButton,
    SideIndicator,
    ModalCalculate,
    ModalMain,
    MoneyFormat,
    OnboardingTopBar,
    OnboardingButton,
    VueSkeletonLoader,
  },
  data() {
    return {
      welcomeText: "Begin your ZedLite journey here",
      activeIndex: 0,
      showLoading: false,
      canContinue: false,
      nextPageName: "OnboardIPPPaymentSummary",
      showIpp: false,
      showStandard: false,
      showCustomerType: true,
      activePackageType: {},
      activeCustomerType: {},
      activeProduct: {},
      products: [],
      stateId: null,
      onboardingStateId: null,
      LVI_REGIONS: ["lekki", "victoria_island", "ikoyi"],
      // isLVIRegion: false,
    };
  },
  methods: {
    async fetchProducts() {
      const state = await this.getCurrentState();
      const { referralname,  customerRegion} = state;

      const hasNoreferral = referralname === null && !this.LVI_REGIONS.includes(customerRegion)
        const isSunfiReferral =
          referralname && referralname.toLowerCase() === "sunfi";
      const canSeeOpulenceProducts =
        hasNoreferral || isSunfiReferral;
      try {
        this.showLoading = true;
        const HTTP = this.$httpUtils.FASTHTTP;
        // fetch products from backend based on system series or lvi region
        let url = ""

        if (canSeeOpulenceProducts) {
          url = "/product/products?system_series=opulence"
        } else {
          url = "/product/products"
        }
        let res = await HTTP.get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("appUserToken")}`,
          },
        });

        // parse for "arnergy-select" use
        return res.data
          .map((item) => {
            return {
              id: item.id,
              name: item.producttype,
              productDescription: item.productdescription,
              amountOS: item.amountos,
              monthlyAmountLO: item.monthlyamountlo,
              tenure: item.tenurelo,
              url_image: item.image_url,
              maintenance_fee: item.maintenance_fee,
              installation_cost: item.installation_cost,
              system_type: item.system_type,
              equipment_cost: item.equipment_cost,
              logistics_cost: item.logistics_cost,
            };
          })
          .sort((a, b) => {
            return a.name > b.name ? 1 : -1;
          });
      } catch (error) {
        console.log("error fetching onboarding products >>>>>", error);
      } finally {
        this.showLoading = false;
      }
    },
    setActiveProduct(item) {
      this.welcomeText = item.productDescription;
      this.activeProduct = item;
      this.canContinue = true;
    },
    updateGlobalState() {
      const onboardingCustomerState = this.$store.state.onboardingCustomerState;
      this.$store.commit("saveOnboardingCustomerState", {
        ...onboardingCustomerState,
        product_id: this.activeProduct.id,
        selectedProduct: this.activeProduct,
      });
    },
    handleContinue() {
      this.updateGlobalState();
      OnboardingService.updateDbData({
        currentPageName: this.nextPageName,
        product_id: this.activeProduct.id,
      });
      this.navTo(this.nextPageName);
    },
    getCustomerRegion() {
      const customerRegion = this.$store.state.onboardingCustomerState.customerRegion;
      if (customerRegion && this.LVI_REGIONS.includes(customerRegion.toLowerCase())) {
        return true;
      }
      return false;
    },
async getCurrentState() {
      const HTTP = this.$httpUtils.FASTHTTP;
      const url = "/onboardingstate/state";
      try {
        const response = await HTTP.get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("appUserToken")}`,
          },
        });
        console.log("response.data", response.data);
        return response.data;
      } catch (error) {
        console.log({ error });
      }
    },
  },
  async mounted() {
    // await this.getCustomerRegion();
    this.products = await this.fetchProducts();
    this.onboardingStateId = localStorage.getItem("onboardingStateId");
    // await this.updateStatus();
  },
};
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  width: 100%;
  padding: 0rem 14rem;
  font-family: "DM Sans";
  background: #ffffff;

  @media screen and (max-width: 600px) {
    padding: 0rem 2rem;
    flex-direction: column-reverse;
  }
}

.choose-package {
  width: 70%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media screen and (max-width: 600px) {
    width: 100%;
  }
}

.button {
  border: 1px solid #0892d0;
  border-radius: 5px;
  padding: 7px 10px;
}

.welcome {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 39px;
  color: #0892d0;
  margin-bottom: 2.1rem;
}

.subtext {
  font-family: "DM Sans";
  max-width: 58.1rem;
  width: 100%;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #727272;
  margin-bottom: 2.7rem;
}

.choice-type {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 2.7rem;
  color: #fe7a11;
}

.boxes {
  display: flex;
  margin-bottom: 2.7rem;

  @media screen and (max-width: 600px) {
    width: 100%;
  }
}

.package {
  display: grid !important;
  grid-template-columns: 1fr 1fr 1fr;
  row-gap: 20px;
  margin-bottom: 2.7rem;
}

.right-image {
  display: flex;
  flex-direction: column;
}

.description {
  max-width: 340px;
  border-radius: 40px;
  padding: 32px 20px;
  background: #e6f6ff;
  text-align: center;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #0892d0;
}

.man-woman {
  margin-bottom: 9rem;
}

.continue {
  display: block;
  margin-left: auto;
  margin-right: 0;
}

.polygon {
  width: 5.3rem;
  height: 5.8rem;
  margin-left: 21rem;
  margin-top: -1.5rem;
}

@media screen and (max-width: 430px) {
  .package {
    grid-template-columns: 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/ipp/index.vue